import styled, { css } from 'vue-styled-components';

import { GRAY, FLEX_CENTER } from '@/styles/common.styled';

import { FLEX_COLUMN_DIV } from '@/styles/common.styled.component';

export const ComponentWrapper = styled('div', {
    isDisabled: Boolean,
    customStyle: Array,
})`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    padding: 11px 16px;
    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg.total_row-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }

            h1 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 6px;
            }
        }
    }

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            cursor: not-allowed;
            background-color: #ebeef0;
        `}

    ${({ customStyle }) => customStyle}
`;

export const ContentWrapper = styled(FLEX_COLUMN_DIV)`
    height: 100%;
    background-color: #fff;
    .dummy {
        height: 20px;
        width: 100%;
        flex-shrink: 0;
        margin-top: -20px;
        z-index: 1;
        position: sticky;
        top: -20px;
        background-color: #fff;
    }
`;
